export class NotificationResolveRequest {

    _solved; // boolean
    _notificationIds; // number[]

    constructor() {
        this._notificationIds = [];
    }

    setNotification(notification) {
        this._notificationIds = [notification.id()];
    }

    setResolution(solved) {
        this._solved = solved;
    }

    body() {
        return {
            notificationIds: this._notificationIds,
            solved: this._solved,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/list/notification-resolve/NotificationResolveRequest.js